module.exports = __webpack_public_path__ + "img/home-book.00f3b733.svg";